module.exports = __webpack_public_path__ + "img/nextjs-logo.33e463a9.png";